import { render, staticRenderFns } from "./commentbox.vue?vue&type=template&id=582e9278&"
import script from "./commentbox.vue?vue&type=script&lang=js&"
export * from "./commentbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports